module.exports = __webpack_public_path__ + "img/goal01.dcb66ad0.png";